import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)
/* eslint-disable */

// Jquery easing
jQuery.easing.jswing = jQuery.easing.swing;
jQuery.extend(jQuery.easing, {
    def: "easeOutQuad",
    swing: function (e, f, a, h, g) {
        return jQuery.easing[jQuery.easing.def](e, f, a, h, g)
    },
    easeInQuad: function (e, f, a, h, g) {
        return h * (f /= g) * f + a
    },
    easeOutQuad: function (e, f, a, h, g) {
        return -h * (f /= g) * (f - 2) + a
    },
    easeInOutQuad: function (e, f, a, h, g) {
        if ((f /= g / 2) < 1) {
            return h / 2 * f * f + a
        }
        return -h / 2 * ((--f) * (f - 2) - 1) + a
    },
    easeInCubic: function (e, f, a, h, g) {
        return h * (f /= g) * f * f + a
    },
    easeOutCubic: function (e, f, a, h, g) {
        return h * ((f = f / g - 1) * f * f + 1) + a
    },
    easeInOutCubic: function (e, f, a, h, g) {
        if ((f /= g / 2) < 1) {
            return h / 2 * f * f * f + a
        }
        return h / 2 * ((f -= 2) * f * f + 2) + a
    },
});

function formSubmitGeneral(id, actionName, formStringName) {
    let formEl = document.querySelector(`#${ id }`)
    console.log('formEl', formEl);

    let form = {
        container: formEl,
        inner: formEl.querySelector('.form-inner'),
        response: formEl.querySelector('.form-response-wrap'),
        success: formEl.querySelector('.form-response-wrap .success'),
        failed: formEl.querySelector('.form-response-wrap .failed'),
        formName: formStringName,
        dur_one: 0.4,
        dur_two: 0.5,
    }

    console.log(form, form.container);
    
    form.container.addEventListener('submit', event => {
        event.preventDefault()
        event.stopImmediatePropagation();

        const formData = new FormData(event.target);
        form.formData = new Object();

        formData.append('page', window.location.href)
        formData.append('page-id', document.querySelector('#wrap').dataset.pageId)
        // formData.append('page-meta-title', meta[property = "og:title"])
        formData.append('page-meta-title', document.querySelector('#wrap').dataset.pageName)

        form.formData = formData

        // Wp Ajax action
        let url = wpUrl(`?action=${ actionName }`)

        console.log('url', url);

        // Ajax function
        formAjaxToWp(url, form);

        // formResponseAnim(form, form.success)
    })
}

// Get wp ajax url
function wpUrl(url) {
    // Get ajax url
    let ajaxUrl = window.ajax_object.ajax_url;

    // Change ajax url for protocol
    if (window.location.protocol == 'http:' && window.location.hostname != "gatto.bwsdemo.com") {
        ajaxUrl = ajaxUrl.split('http');

        if (window.location.host == "localhost:3000") {
            ajaxUrl = 'http' + ajaxUrl[1];
        } else {
            ajaxUrl = 'https' + ajaxUrl[1];
        }
    }

    // Add url parameters
    ajaxUrl = ajaxUrl + url;

    return ajaxUrl;
}

// Form response anim
function formResponseAnim(obj, responseType) {
    let tl = gsap.timeline({
        defaults: { ease: "power2.out" },
    })

    // Scroll to of form
    let getLastPart = obj.container;
    
    // Page ID location
    let toPageLocation = $(getLastPart).offset().top - 100;
    let toPageLocationMobile = $(getLastPart).offset().top - 80;

    let header = document.querySelector('#bws-header').getBoundingClientRect().height + 20
    // let header = document.querySelector('#bws-header').getBoundingClientRect().height

    // Halved to offset smooth scroll
    // let halfLocation = (toPageLocation / 1.7);
    // let halfLocationMobile = toPageLocationMobile;

    if (obj.formName == "careers form" || 
        obj.formName == "book an appointment form") {
        let div = obj.container.closest('.bws-modal')
        div.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    } else {
        // Page scroll animation
        let v = $(getLastPart).offset().top - (header)
    
        if (window.innerWidth >= 1025) {
            window.smooth.scrollTo(v)
        } else {
            gsap.to(window, {
                scrollTo: v,
            })
        }
        
        /*
        if ($(window).width() >= 1024) {
            $('html,body').stop().animate({
                // scrollTop: $(getLastPart).offset().top
                // scrollTop: $(getLastPart).offset().top - (header / 2),
                // scrollTop: $(getLastPart).offset().top - (header),
                // scrollTop: getLastPart.scrollTop,
                // scrollTop: 4596.390625,
                // scrollTop: 4596.390625 - header,
                scrollTop: $(getLastPart).offset().top - (header),
                easing: 'easeInOutQuad',
            }, 200);
        } else {
            $('html,body').stop().animate({
                scrollTop: $(getLastPart).offset().top - header,
                easing: 'easeInOutQuad',
            }, 200);
        }
        */
        
    }

    tl.to(obj.inner, {
        duration: obj.dur_one,
        opacity: 0,
        delay: 0.8,
    })
    tl.fromTo(obj.inner, {
        height: obj.inner.getBoundingClientRect().height,
    }, {
        duration: obj.dur_two,
        height: 0,
    })
    tl.fromTo([responseType, obj.response], {
        height: 0,
    }, {

        duration: obj.dur_two,
        height: responseType.children[0].getBoundingClientRect().height,
        onComplete: () => {
            responseType.style.height = 'auto';
            // window.lScroll.update();
            // ScrollTrigger.refresh()

            if (window.innerWidth >= 1025) {
                document.querySelector('.vs-scroll-view').style.height = `${document.querySelector('.vs-section').getBoundingClientRect().height}px`
            }
        },
    }, `-=${obj.dur_two}`)
    tl.to(responseType.children[0], {
        duration: obj.dur_one,
        opacity: 1,
    })
}

// Form submit ajax
function formAjaxToWp(url, form) {
    let options = {
        method: 'POST',
        mode: 'no-cors',
        body: form.formData,
    }

    console.log(url, form);
    
    fetch(url, options)
        .then(response => response.json())
        .then(data => {
            // eslint-disable-next-line
            console.log(data);

            // let returnData = data.data
            let returnData = data
            console.log('returnData', returnData);

            if (returnData.result == "Queued. Thank you.") {
                // console.log('success form', form);
                formResponseAnim(form, form.success)
            } else {
                formResponseAnim(form, form.failed)
            }

        })
        .catch((error) => {
            formResponseAnim(form, form.failed)

            // eslint-disable-next-line
            console.log(error)
        });     
}

function fileInput() {
    let files = Array.from(document.querySelectorAll('input[type=file]'));
    console.log(files);

    files.forEach(file => {
        file.addEventListener('click', (event) => {
            console.log('click', event);
        });

        file.addEventListener('change', (event) => {
            console.log(event);

            let copy = event.target.parentElement.querySelector('.text');

            console.log('copy', copy);

            let row = event.target.closest('.upload-file')
            let formEl = event.target.closest('form')
            // let label = row.querySelector('label')
            let maxFileSize = 26214400; // 25MB
            let previewBool = false;

            let fileObj = new Object()

            console.log('event.target.files', event.target.files);

            // See if max file size is exceded
            if (event.target.files.length > 0) {
                Array.from(event.target.files).forEach((file_, index_) => {
                    console.log(file_);
                    copy.textContent = file_.name

                    if (file_.size >= maxFileSize) {
                        displayErrorMesage(copy, row, formEl)
                    } else if (row.querySelector('.error-message') !== null) {
                        hideErrorMessage(copy, row, formEl)
                    }

                    console.log('file_', file_);

                    fileObj[index_] = {
                        'lastModified': file_.lastModified,
                        'lastModifiedDate': file_.lastModifiedDate,
                        'name': file_.name,
                        'size': file_.size,
                        'type': file_.type,
                        'webkitRelativePath': file_.webkitRelativePath
                    };
                })
                // 'tmp_name': file_.lastModified + file_.name,
                console.log('fileObj', fileObj);
                // window.localStorage.setItem('resume-upload', JSON.stringify(fileObj))
            } else {
                copy.textContent = "No file selected"
                window.localStorage.removeItem('resume-upload')
            }
        })

        file.addEventListener('dragover', (event) => {
            let row = event.target.closest('.upload-file')
            gsap.to([row.querySelectorAll('svg path'), row.querySelector('.text')], {
                duration: 0.4,
                fill: '#1b1c1d80',
                color: '#1b1c1d80',
                ease: "power1.out",
                overwrite: true,
            });
        }, false);

        // Animate dragleave
        file.addEventListener('dragleave', (event) => {
            let row = event.target.closest('.upload-file')
            resetFileInputColor(row)
        }, false);

        // After drag drop - reset color after
        file.addEventListener('mouseleave', (event) => {
            let row = event.target.closest('.upload-file')
            resetFileInputColor(row)
        }, false);

        // Prevent submission
        file.addEventListener('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
    });

    function resetFileInputColor(row) {
        gsap.to([row.querySelectorAll('svg path'), row.querySelector('.text')], {
            duration: 0.4,
            color: '#1B1C1D',
            fill: '#1B1C1D',
            ease: "power1.out",
            overwrite: true,
        });
    }
}

export { formSubmitGeneral, fileInput }


// WEBPACK FOOTER //
// ./scripts/components/forms.js